import { Box } from '@glplus/glpweb-dsl';

/** A custom-colored pill (DSL Chip only supports preset palettes). */
export function Pill({
  label,
  fg,
  bg,
  strong = false,
}: {
  label: string;
  fg: string;
  bg: string;
  strong?: boolean;
}) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1,
        py: '2px',
        borderRadius: '10px',
        backgroundColor: bg,
        color: fg,
        fontSize: '11px',
        fontWeight: strong ? 700 : 600,
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Box>
  );
}
